const messages = {
  $public_onboarding: {
    accounting: {
      select_average_monthly: "Select average yearly expenses",
    },
    checkout_values: {
      monthly_expense: "yearly expenses",
    },
    fields: {
      placeholder: {
        quarterly_average: "Estimated average yearly expenses.",
      },
      input: {
        invalid_quarterly: "Invalid quarterly average yearly expense"
      }
    },
    cart_summary_accounting: {
      accounting_tax:
        "Accounting Plan - Accounting & Tax </br> ({price} annual revenue)",
      accounting_annual_filling:
        "Annual Bookkeeping - up to {price} Yearly expenses",
      accounting_payroll:
        "Accounting & Payroll - up to {price} Yearly expenses",
      accounting_premium:
        "Accounting Premium - up to {price} Yearly expenses",
      above_value: "Accounting - Above {price} Yearly expenses",
      accounting_tax_return_only:
        "Tax and return only - {price} annual revenue",
      accounting_tax_payroll:
        "Acounting, Tax & Payroll - {price} annual revenue",
      sole_trader_tax_accounting:
        "Sole Trader Tax & Accounting - {price} annual revenue",
      sole_trader_tax_return:
        "Sole Trader Tax Return - {price} annual revenue",
      tax_return_only: "Tax and return only - {price} annual revenue",
    },
    included: "Included",
  },
  $accounting: {
    packages: {
      monthly_expenses1: "yearly expenses",
      plan_details: {
        selected_estimate: "Selected your estimated average yearly expenses",
        faciliate_discussion: "To faciliate the discussion, please specify your estimated average yearly expenses.",
      }
    },
  }
};

export default messages;
